import React, { useEffect, useState } from "react";
import {
	Alert,
	Box,
	Button,
	CircularProgress,
	Grid,
	Paper,
	Chip,
	Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link as RouterLink } from "react-router-dom";

import { SubHeader } from "../../../utils/componentes-utiles/SubHeader";
import { PermisosOpciones } from "./PermisosOpciones";
import {
	actualizarPermisosOperativa,
	getPermisosOperativa,
} from "../../../services/apis";

export const PermisosOperativa = () => {
	const [roles, setRoles] = useState([]);
	const [grupos, setGrupos] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");


	const cargarPermisos = async () => {
		setLoading(true);
		setError("");

		try {
			const response = await getPermisosOperativa();

			if (response?.success === true) {
				setRoles(Array.isArray(response?.data?.roles) ? response.data.roles : []);
				setGrupos(Array.isArray(response?.data?.opciones) ? response.data.opciones : []);
				return;
			}

			setRoles([]);
			setGrupos([]);
			setError(response?.message || "No se pudieron cargar los permisos de operativa.");
		} catch (loadError) {
			console.error("Error cargando permisos de operativa:", loadError);
			setRoles([]);
			setGrupos([]);
			setError(
				loadError?.response?.data?.message ||
					"No se pudieron cargar los permisos de operativa."
			);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		void cargarPermisos();
	}, []);

	const guardarPermisosGrupo = async (updatedOpciones, tableName) => {
		const response = await actualizarPermisosOperativa(updatedOpciones, tableName);

		if (response?.success !== true) {
			throw new Error(
				response?.message || "No se pudieron guardar los permisos del bloque."
			);
		}
	};

	return (
		<Grid container justifyContent="center" size={{ xs: 12 }}>
			<SubHeader titulo="Permisos y visibilidad" />

			<Grid container size={{ xs: 11, xl: 10 }} sx={{ mb: 2 }}>
				<Button
					variant="text"
					startIcon={<ArrowBackIcon />}
					component={RouterLink}
					to="/admin"
				>
					Volver a administracion
				</Button>
			</Grid>

			<Grid container size={{ xs: 11, xl: 10 }} sx={{ mb: 2 }}>
				<Alert severity="info" sx={{ width: "100%" }}>
					Desde aqui puedes decidir que roles ven cada opcion principal del sistema.
					Este panel centraliza menu principal, RRHH, documentacion y administracion.
				</Alert>
			</Grid>

			{!loading && !error && grupos.length > 0 && (
				<Grid container size={{ xs: 11, xl: 10 }} sx={{ mb: 2 }}>
					<Paper
						variant="outlined"
						sx={{
							width: "100%",
							p: 2,
							borderRadius: 2,
							bgcolor: "grey.50",
							borderColor: "divider",
							boxShadow: "none",
						}}
					>
						<Box
							sx={{
								display: "flex",
								flexDirection: { xs: "column", md: "row" },
								alignItems: { xs: "flex-start", md: "center" },
								justifyContent: "space-between",
								gap: 1.5,
							}}
						>
							<Box>
								<Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
									Configura la visibilidad por bloques
								</Typography>
								<Typography variant="body2" color="text.secondary">
									Cada bloque agrupa opciones de una tabla distinta y guarda los cambios
									automaticamente.
								</Typography>
							</Box>

							<Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
								<Chip size="small" variant="outlined" label={`${roles.length} roles`} />
								<Chip size="small" variant="outlined" label={`${grupos.length} bloques`} />
							</Box>
						</Box>
					</Paper>
				</Grid>
			)}

			{loading && (
				<Grid container justifyContent="center" size={{ xs: 11, xl: 10 }} sx={{ py: 4 }}>
					<CircularProgress />
				</Grid>
			)}

			{!loading && error && (
				<Grid container size={{ xs: 11, xl: 10 }}>
					<Alert
						severity="error"
						action={
							<Button color="inherit" size="small" onClick={cargarPermisos}>
								Reintentar
							</Button>
						}
						sx={{ width: "100%" }}
					>
						{error}
					</Alert>
				</Grid>
			)}

			{!loading && !error && grupos.length === 0 && (
				<Grid container size={{ xs: 11, xl: 10 }}>
					<Alert severity="warning" sx={{ width: "100%" }}>
						No hay bloques de permisos configurados para mostrar.
					</Alert>
				</Grid>
			)}

			{!loading && !error && grupos.length > 0 && (
				<Grid container justifyContent="center" size={{ xs: 11, xl: 10 }}>
					{grupos.map((grupo, index) => (
						<PermisosOpciones
							key={grupo.url || `${grupo.nombre}-${index}`}
							roles={roles}
							opciones={grupo.opciones}
							title={grupo.nombre}
							nombreArray={grupo.url}
							descripcion={grupo.descripcion}
							index={index}
							onUpdatePermissions={(updatedOpciones) =>
								guardarPermisosGrupo(updatedOpciones, grupo.url)
							}
						/>
					))}
				</Grid>
			)}
		</Grid>
	);
};
